/* eslint-disable max-lines-per-function */
const rounded = value => Math.round(value);
const isLazyImageReady = image =>
  (image.classList.contains("lazyloaded") || image.classList.contains("eagerload")) &&
  image.complete;
const noop = () => {};

const getCursorPosition = (image, event = window.event) => {
  const rect = image.getBoundingClientRect();
  const x = event.pageX - rect.left - window.pageXOffset;
  const y = event.pageY - rect.top - window.pageYOffset;
  return { x, y };
};

const preloadImage = (src, callback) => {
  const img = new Image();
  img.src = src;
  img.onload = callback;
};

const getPreviewSize = (width, height, SELECTORS) => {
  const panel = document.querySelector(SELECTORS.PANEL);
  const carouselImage = document.querySelector(SELECTORS.ACTIVE_CAROUSEL_ITEM);
  const vh = window.innerHeight || window.clientHeight || window.clientHeight;
  const gap = 24;

  const panelSizes = panel.getBoundingClientRect();
  const carouselSizes = carouselImage.getBoundingClientRect();

  const carouselSize = {
    height: carouselSizes.height,
    width: carouselSizes.width
  };

  const actualHeight = Math.min(panelSizes.top > 0 ? vh - panelSizes.top : vh, panelSizes.width);
  const sizes = {
    width: panelSizes.width, // Math.min(width, panelSizes.width),
    height: actualHeight - gap // Math.min(height, actualHeight) - gap
  };
  const lensWidth = (sizes.width / width) * carouselSize.width;
  const lensHeight = (sizes.height / height) * carouselSize.height;

  return {
    carouselWidth: carouselSizes.width,
    carouselHeight: carouselSizes.height,
    width: sizes.width,
    height: sizes.height,
    lensWidth: Math.min(lensWidth, carouselSize.width),
    lensHeight: Math.min(lensHeight, carouselSize.height)
  };
};

const previewClass = "js-zoom-preview product-details-image-carousel__preview";
const threshold = 1.5; // 1.5px
let lastMoveAnimation = null;

const initImageZoom = SELECTORS => {
  const carousel = document.querySelector(SELECTORS.DEFAULT_CAROUSEL);
  if (!carousel) return [];

  const items = Array.from(carousel.querySelectorAll(SELECTORS.CAROUSEL_ITEM));
  const previewWrapper = document.querySelector(SELECTORS.PREVIEW_WRAPPER);
  const lightboxToggler = document.querySelector(SELECTORS.PRODUCT_LIGHTBOX_TOGGLER);
  previewWrapper.textContent = "";

  // items hover
  return items.map(element => {
    const image = element.querySelector(SELECTORS.IMAGE);
    const lens = element.querySelector(SELECTORS.LENS);

    if (!image || !lens) {
      return noop;
    }

    const { zoomSrc, src, width, height } = image.dataset;
    const preview = document.createElement("div");
    previewWrapper.appendChild(preview);
    preview.className = previewClass;

    if (!height || !width) {
      return noop;
    }

    let cx = 0;
    let cy = 0;
    let zoomDisabled = false;
    let oldX = null;
    let oldY = null;
    let moveX = true;
    let moveY = true;

    // adjust preview & lens sizes
    const handleResize = () => {
      const previewSize = getPreviewSize(width, height, SELECTORS);
      const zoomImage = isLazyImageReady(image) ? zoomSrc : src;
      const bgWidth = Math.min(width, image.width * cx);
      const bgHeight = Math.min(image.height * cy, height);
      moveX = previewSize.width < width;
      moveY = previewSize.height < height;
      const bgXPosition = moveX ? "0px" : "center";
      const bgYPosition = moveY ? "0px" : "center";
      zoomDisabled = height < previewSize.carouselHeight || width < previewSize.carouselWidth;

      previewWrapper.style.width = `${previewSize.width}px`;
      previewWrapper.style.height = `${previewSize.height}px`;

      preview.style.width = `${previewSize.width}px`;
      preview.style.height = `${previewSize.height}px`;

      lens.style.width = `${previewSize.lensWidth}px`;
      lens.style.height = `${previewSize.lensHeight}px`;
      lens.style.visibility = "hidden";

      cx = previewWrapper.offsetWidth / lens.offsetWidth;
      cy = previewWrapper.offsetHeight / lens.offsetHeight;

      preview.style.backgroundImage = `url('${zoomImage}')`;
      preview.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
      preview.style.backgroundPosition = `${bgXPosition} ${bgYPosition}`;
      preview.style.visibility = "hidden";
    };

    const handleMove = event => {
      const pos = getCursorPosition(image, event);
      let x = pos.x - lens.offsetWidth / 2;
      let y = pos.y - lens.offsetHeight / 2;
      event.preventDefault();

      if (x > image.width - lens.offsetWidth) {
        x = image.width - lens.offsetWidth;
      }

      if (x < 0) {
        x = 0;
      }

      if (y > image.height - lens.offsetHeight) {
        y = image.height - lens.offsetHeight;
      }

      if (y < 0) {
        y = 0;
      }

      if (oldX != null && oldY != null) {
        if (Math.abs(oldX - x) < threshold && Math.abs(oldY - y) < threshold) {
          return;
        }
      }

      oldX = x;
      oldY = y;

      lastMoveAnimation = requestAnimationFrame(() => {
        const bgWidth = Math.min(width, image.width * cx);
        const bgHeight = Math.min(image.height * cy, height);
        const bgXPosition = moveX ? `-${rounded(x * cx)}px` : "center";
        const bgYPosition = moveY ? `-${rounded(y * cy)}px` : "center";
        lens.style.left = `${rounded(x)}px`;
        lens.style.top = `${rounded(y)}px`;
        preview.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
        preview.style.backgroundPosition = `${bgXPosition} ${bgYPosition}`;
        lastMoveAnimation = null;
      });
    };

    const handleMouseover = event => {
      if (!isLazyImageReady(image) || zoomDisabled) return;

      handleResize();
      handleMove(event);
      preview.style.visibility = "visible";
      lens.style.visibility = "visible";
    };

    const handleMouseout = () => {
      if (lastMoveAnimation) cancelAnimationFrame(lastMoveAnimation);
      preview.style.visibility = "hidden";
      lens.style.visibility = "hidden";
    };

    const handleClick = () => image.parentNode.click();

    const carouselImageLoaded = () => {
      preloadImage(zoomSrc, () => {
        preview.style.backgroundImage = `url('${zoomSrc}')`;
      });
    };

    if (isLazyImageReady(image)) {
      carouselImageLoaded();
    }

    image.addEventListener("mousemove", handleMove);
    image.addEventListener("load", carouselImageLoaded, { passive: true });
    lens.addEventListener("mousemove", handleMove);
    lens.addEventListener("click", handleClick, { passive: true });
    element.addEventListener("mouseover", handleMouseover);
    element.addEventListener("mouseout", handleMouseout, { passive: true });
    window.addEventListener("resize", handleResize, { passive: true });
    if (lightboxToggler) {
      lightboxToggler.addEventListener("click", handleResize, { passive: true });
    }

    // initial run
    setTimeout(() => {
      handleResize();
    }, 0);

    return () => {
      image.removeEventListener("mousemove", handleMove);
      image.removeEventListener("load", carouselImageLoaded, { passive: true });
      lens.removeEventListener("mousemove", handleMove);
      lens.removeEventListener("click", handleClick, { passive: true });
      element.removeEventListener("mouseover", handleMouseover);
      element.removeEventListener("mouseout", handleMouseout, { passive: true });
      window.removeEventListener("resize", handleResize, { passive: true });
      if (lightboxToggler) {
        lightboxToggler.removeEventListener("click", handleResize, { passive: true });
      }
    };
  });
};

export default initImageZoom;
